<template>
    <v-tooltip bottom open-delay="100" v-if="hasToolTip">
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">{{ displayName }}</span>
        </template>
        <span>{{ tooltipValue }}</span>
    </v-tooltip>
    <span v-else>
        <span>{{ displayName }}</span>
    </span>
</template>
<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    computed: {
        displayName() {
            if (!this.user) return ''
            return this.user.displayName || this.tooltipValue
        },
        hasToolTip() {
            return !!this.user.displayName
        },
        tooltipValue() {
            return this.user.firstName + (this.user.lastName ? ' ' + this.user.lastName : '')
        },
    },
}
</script>
